export const NotfoundIcon = ({ width, height, color }) => {
  return (
    <svg width={width} height={height} color={color} viewBox="0 0 256 256">
      <circle
        cx="116"
        cy="116"
        r="84"
        fill="currentColor"
        opacity=".2"
      ></circle>
      <path
        fill="currentColor"
        d="m229.7 218.3l-43.3-43.2a92.2 92.2 0 1 0-11.3 11.3l43.2 43.3a8.2 8.2 0 0 0 11.4 0a8.1 8.1 0 0 0 0-11.4ZM40 116a76 76 0 1 1 76 76a76.1 76.1 0 0 1-76-76Z"
      ></path>
    </svg>
  );
};

// width={width} height={height} color={color}
